import { create } from 'zustand';

interface initDataState {
  param: any;
  bindParam: any;
  result: any;
  initPayload: any;
  payload: any;
  bind: (result: { data: any }) => void;
  bindPayload: (payload: { data: any }) => void;
}

// 주택 자금저축
export const initSavingsPayload = {
  name: '', //사용자명
  acct_year: '', //연말정산   년도
  co_cd: '', //회사코드
  co_id: '', //사번
  in_data_seqid: 0, //입력데이터 sequence
  data_type: '1', // 1:청약저축,2:주택청약종합저축,4:근로자주택마련저축
  htx_amt: 0, //금액(국세청)
  amt: 0, //금액(일반)
  question_status: '', //설문상태
  bank_cd: '', //은행코드
  account_num: '', //계좌번호
  sbp_date: '', //청약일
  is_htx_pdf: 'Y', //국세청사용여부
};

/**
  주택 자금저축
**/
export const savingsDataStore = create<initDataState>(set => ({
  param: { initialSeq: 0 },
  bindParam: (bind: any) =>
    set(state => ({
      ...state,
      param: { ...state.param, ...bind },
    })),
  result: [],
  bind: (data: any) =>
    set(state => ({
      ...state,
      result: { ...state.result, ...data },
    })),
  initPayload: initSavingsPayload,
  payload: initSavingsPayload,
  bindPayload: (data: any) =>
    set(state => ({
      ...state,
      payload: { ...state.payload, ...data },
    })),
}));
